import Image from "next/image"

export const RedesignAccountEmpty = ({ kind }: { readonly kind: "history" | "notifications" }) => (
  <section className="redesign-account-empty" data-redesign-empty={kind}>
    {kind === "notifications" ? (
      <span aria-hidden="true" className="redesign-account-empty-icon">
        <Image alt="" height={22} src="/assets/cashhub/redesign/account-bell.svg" width={22} />
      </span>
    ) : null}
    <div>
      <h2>{kind === "notifications" ? "새로운 알림이 없어요" : "아직 이용 내역이 없어요"}</h2>
      <p>
        {kind === "notifications" ? (
          <>
            중요한 전환 및 상품 처리 소식을
            <br />
            이곳에서 알려드릴게요.
          </>
        ) : (
          <>
            전환하거나 사용한 내역이 생기면
            <br />
            시간순으로 보여드릴게요.
          </>
        )}
      </p>
    </div>
  </section>
)
